var styleDataHash = "8b2b1772";
const injectCss = () => {
  var css = `.AUTrD{height:18px;position:relative;width:18px}.F4r7i,.JdB-f{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .F4r7i,[dir=ltr] .JdB-f{left:0}[dir=rtl] .F4r7i,[dir=rtl] .JdB-f{right:0}.F4r7i{stroke:currentColor;opacity:.3}[dir=ltr] .F4r7i{animation:lEZnP 666ms linear infinite}[dir=rtl] .F4r7i{animation:p5HAX 666ms linear infinite}.JdB-f{stroke:currentColor}[dir=ltr] .JdB-f{animation:lEZnP 2s linear infinite}[dir=rtl] .JdB-f{animation:p5HAX 2s linear infinite}@keyframes lEZnP{to{transform:rotate(1turn)}}@keyframes p5HAX{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "AUTrD",
  "top": "F4r7i",
  "bottom": "JdB-f",
  "rotation-ltr": "lEZnP",
  "rotation-rtl": "p5HAX"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
